import React from 'react';
import ReactDOM from 'react-dom';
import Event from '../Event.js';
import Select from 'react-select';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import SiteConfig from '../SiteConfigs';
import Url from "../Url";
import ErrorBoundary from '../../ErrorBoundary.js';

class OptionsModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            title: '',
            country: 'us',
            show: false,
            altTitle: null,
            triggerTitle: '',
            icon: 'pencil',
            path: '',
            showCountrySelector: false,
            options: null,
            countries: null,
            hash: ''
        };
    }

    componentDidMount() {
        if (this.props.country) {
            this.setState({ country: this.props.country });
        }

        Event.on('optionsModal.show', (data) => {
            if (data.hasOwnProperty('title') && data.hasOwnProperty('path')) {
                this.setState({ title: data.title, altTitle: data.altTitle, triggerTitle: data.triggerTitle, path: data.path, icon: data.icon, hash: data.hash }, () => {
                    this.setState({ show: true, showCountrySelector: false });
                });
            }
        }, this._rootNodeID);

        Event.on('country.change', (data) => {
            this.setState({ country: (data ? data : 'us') });
        }, this._rootNodeID);

        Event.on('modals.close', () => {
            this.setState({ show: false });
        }, this._rootNodeID);

        SiteConfig.get('bluecompass.mandyHomePage.sitesBase', (options) => {
            this.setState({ options });
        });

        SiteConfig.get('bluecompass.mandyHomePage.countries', (countries) => {
            this.setState({ countries });
        });
    }

    componentWillUnmount() {
        Event.off('optionsModal.show', this._rootNodeID);
        Event.off('country.change', this._rootNodeID);
        Event.off('modals.close', this._rootNodeID);
    }

    getLocationOptions() {
        if (this.state.countries) {
            return this.state.countries.map((item) => ({ value: item.code, label: item.name }));
        }
    }

    getItemUrl(item) {
        let url = '#';
        switch (this.state.path) {
            case 'search':
                url = Url.prefixedUrl(`mandy.com/search?country=${this.state.country}&domain=${item.domain}`);
                break;
            case 'jobs':
                let auditions = item.performers ? '/auditions' : '';
                let type = item.domain.replace('.mandy', '');
                url = Url.prefixedUrl(`mandy.com/jobs${auditions}/${this.countryName()}/${type}`);
                break;
            default:
                url = Url.prefixedUrl(`mandy.com/${this.state.path}?country=${this.state.country}&domain=${item.domain}`);
                break;
        }
        return url;
    }

    countryName() {
        let countryItem = this.state.countries.find(country => country.code === this.state.country);
        return countryItem && countryItem.name ? countryItem.name.toLowerCase() : '';
    }

    showOptions() {
        if (this.state.options) {
            return this.state.options.filter((option) => {
                if (option.hasOwnProperty('countries')) {
                    return option.countries.indexOf(this.state.country) !== -1;
                }
                return true;
            }).map((item, index) => {
                return (
                    <div className="col-lg-4 mb-2 d-none d-lg-block" key={index}>
                        <a href={this.getItemUrl(item)}
                            className={`btn btn-primary btn-block btn-lg mb-2`}>{item.title}</a>
                    </div>
                );
            });
        }
    }

    showOptionsLinks() {
        if (this.state.options) {
            return this.state.options.filter((option) => {
                if (option.hasOwnProperty('countries')) {
                    return option.countries.indexOf(this.state.country) !== -1;
                }
                return true;
            }).map((item, index) => {
                return (
                    <div className="col-lg-4 mb-2 d-lg-none" key={index}>
                        <a href={this.getItemUrl(item)}
                            className={`btn btn-menu btn-outline mb-2 mt-2 btn-block btn-xs`}>{item.title}</a>
                    </div>
                );
            });
        }
    }

    showHeader() {
        if (this.state.hash == '#jobs-guest') {
            return (
                <div className="text-center">
                    <img src={`/assets/img/the-mandy-network-logo1.svg`} className="img-fluid" />
                    <h2 className="py-4 display-3">WELCOME TO THE MANDY JOBS BOARD</h2>
                </div>
            );
        }
    }

    showFooter() {
        if (this.state.hash == '#jobs-guest') {
            return (
                <div className="text-center">
                    <hr />
                    <div className="row">
                        <div className="col-6 col-sm-6 mb-2 pr-1">
                            <button className="btn btn-danger btn-block btn-sm mb-2" onClick={(event) => this.showSignup(event)}>
                                Sign Up
                            </button>
                        </div>
                        <div className="col-6 col-sm-6 mb-2 pl-1">
                            <button className="btn btn-primary btn-block btn-sm mb-2" onClick={(event) => this.showPostJobs(event)}>
                                Post Job
                            </button>
                        </div>
                    </div>
                </div>
            );
        }
    }

    showSignup(event) {
        event.preventDefault();
        Event.fire('modals.close');
        window.location.href = "/signup";
    }

    showPostJobs(event) {
        event.preventDefault();
        Event.fire('modals.close');
        Event.fire('optionsModal.show', {
            'title': 'Post a job for FREE',
            'path': 'jobs/post'
        });
    }

    toggle() {
        this.setState({ show: !this.state.show });
        if (window.location.hash) {
            window.location.hash = '';
        }
    }

    getCountryName() {
        for (let key in this.state.countries) {
            if (this.state.countries.hasOwnProperty(key) && this.state.countries[key].code === this.state.country) {
                return this.state.countries[key].name;
            }
        }
        return 'USA';
    }

    showCountrySelector(event) {
        event.preventDefault();
        this.setState({ showCountrySelector: true });
    }

    changeCountry(value) {
        this.setState({ country: value }, () => {
            Event.fire('country.change', this.state.country);
        });
    }

    showCountryButton() {
        return (
            <div className="d-inline-block w-50 float-right">
                <Select
                    className="mb-0"
                    name="located_in"
                    clearable={false}
                    placeholder="Change Country..."
                    resetValue={{ value: null }}
                    value={this.state.country}
                    options={this.getLocationOptions()}
                    onChange={(val) => this.changeCountry(val.value)}
                />
            </div>
        );
    }

    render() {
        return (
            <Modal isOpen={this.state.show} toggle={() => this.toggle()} className="modal-lg">
                <ModalHeader toggle={() => this.toggle()}>
                    {this.state.triggerTitle ? this.state.triggerTitle : this.state.title}
                </ModalHeader>
                <ModalBody>
                    {this.showHeader()}
                    <div className="">
                        <div className="row mb-2 mt-2">
                            <div className="col-md-12">
                                <h2 className="primary display-4"><strong>
                                    I’d like to {this.state.altTitle ? this.state.altTitle : this.state.title} for:
                                </strong></h2>
                                <a href="#" className="showHide dropdown-toggle btn btn-primary btn-sm btn-block mt-2 d-lg-none" rel="#btn-menu">Select Category</a>
                            </div>
                            {this.showOptions()}
                            <div id="btn-menu" className="col-md-12 p-0 pt-1">
                                {this.showOptionsLinks()}
                            </div>
                        </div>
                    </div>
                    {this.showFooter()}
                </ModalBody>
                <ModalFooter className="pt-2 pb-2">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="offset-md-6 col-md-6 p-0 mb-2 mt-2">
                                {this.showCountryButton()}
                                <p className="secondary d-inline-block mb-0 mt-2 pt-2 float-right">
                                    <img src={`/assets/images/country-flags/${this.state.country}.png`} alt={this.state.country} width="33" className="mr-3" />
                                </p>
                            </div>

                        </div>
                    </div>
                </ModalFooter>
            </Modal>
        );
    }
}

let OptionsModalElement = document.getElementsByClassName('OptionsModal');
if (OptionsModalElement.length > 0) {
    ReactDOM.render(
        <ErrorBoundary>
            <OptionsModal country={window.geoCountry} />
        </ErrorBoundary>, OptionsModalElement[0]
    );
}